// src/pages/AccessDenied.jsx
import React from 'react';
import { ShieldAlert, ArrowLeft } from 'lucide-react';

const AccessDenied = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center p-4">
      <style>{`
        @keyframes pulse-glow {
          0% {
            box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
          }
          70% {
            box-shadow: 0 0 0 30px rgba(239, 68, 68, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
          }
        }
        .pulse-glow {
          animation: pulse-glow 2s infinite;
        }
      `}</style>

      <div className="max-w-lg w-full bg-gray-800/90 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden border border-red-800/40">
        {/* Top accent bar */}
        <div className="h-3 bg-gradient-to-r from-red-600 via-rose-600 to-pink-700"></div>

        <div className="p-10 md:p-12 text-center">
          {/* Pulsing glow icon */}
          <div className="relative mx-auto mb-10 w-36 h-36">
            <div className="absolute inset-0 bg-red-600/40 rounded-full blur-xl pulse-glow"></div>
            <div className="relative w-full h-full bg-red-900/60 rounded-full flex items-center justify-center border-4 border-red-700/50">
              <ShieldAlert className="w-20 h-20 text-red-400" />
            </div>
          </div>

          {/* Dramatic 403 + title */}
          <h1 className="text-9xl font-black bg-clip-text text-transparent bg-gradient-to-r from-red-500 via-rose-500 to-pink-600 tracking-tighter mb-2">
            403
          </h1>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-100 mb-6 tracking-wide">
            Access Denied
          </h2>

          {/* Message */}
          <p className="text-xl text-gray-300 mb-5">
            You don't have the required clearance to enter this zone.
          </p>
          <p className="text-gray-500 mb-12 max-w-md mx-auto">
            This page is restricted. If you believe you should have access, contact an administrator.
          </p>

          {/* Action buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <button
              onClick={() => window.history.back()}
              className="group flex items-center gap-3 px-8 py-4 bg-gray-700/80 text-white rounded-xl hover:bg-gray-600 transition-all duration-300 hover:scale-105 font-semibold shadow-xl backdrop-blur-sm border border-gray-600"
            >
              <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
              Go Back
            </button>

            <a
              href="/"
              className="px-8 py-4 bg-gradient-to-r from-red-600 to-rose-600 text-white rounded-xl hover:from-red-500 hover:to-rose-500 transition-all duration-300 hover:scale-105 font-semibold shadow-xl"
            >
              Return to Home
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-900/50 px-8 py-5 text-center text-sm text-gray-500 border-t border-gray-700">
          © {new Date().getFullYear()} All rights reserved
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;